import script from "./modalUser.vue?vue&type=script&setup=true&lang=js"
export * from "./modalUser.vue?vue&type=script&setup=true&lang=js"

import "./modalUser.vue?vue&type=style&index=0&id=1a1783af&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1783af"]])

export default __exports__